import BlueTableHeading from "../../../../components/common/AdminCommonComponents/BlueTableHeading/BlueTableHeading"
import DynamicDatatable from "../../../../components/common/AdminCommonComponents/DynamicDatatable/DynamicDatatable"
import GrayDivider from "../../../../components/common/AdminCommonComponents/GrayDivider/GrayDivider"
import LightGrayBgWrapper from "../../../../components/common/AdminCommonComponents/LightGrayBgWrapper/LightGrayBgWrapper"
import SearchBar from "../../../../components/common/AdminCommonComponents/SearchBar/SearchBar"
import Avatar from "../../../../assets/images/AdminPortal/FBMManagement/customer-avatar.png"
import FullNameAvatar from "../../../../components/common/AdminCommonComponents/FullNameAvatar/FullNameAvatar"
import ActionButton from "../../../../components/common/AdminCommonComponents/Buttons/ActionButton/ActionButton"
import BlueBadge from "../../../../components/common/AdminCommonComponents/BlueBadge/BlueBadge"
import StatusBadge from "../../../../components/common/AdminCommonComponents/StatusBadge/StatusBadge"
import { useNavigate } from "react-router-dom"

const Sellers = () => {
  const navigate = useNavigate()

  const actions = [
    { label: "View details", action: () => navigate("/user-management/sellers/seller") },
    { label: "Edit", action: () => console.log("Edit") },
    { label: "Delete", action: () => console.log("Delete") },
    { label: "Change status", action: () => console.log("Change status") },
  ]

  const data = [
    {
      sr: "1",
      name: { src: Avatar, fullName: "Full Name" },
      phoneNumber: "03412302789",
      email: "Loremipsum@gmail.com",
      status: "Active",
      products: "10",
      orders: "10",
      lastActive: "June 9,2023",
    },
    {
      sr: "2",
      name: { src: Avatar, fullName: "Full Name" },
      phoneNumber: "03412302789",
      email: "Loremipsum@gmail.com",
      status: "Active",
      products: "10",
      orders: "10",
      lastActive: "June 9,2023",
    },
    {
      sr: "3",
      name: { src: Avatar, fullName: "Full Name" },
      phoneNumber: "03412302789",
      email: "Loremipsum@gmail.com",
      status: "Inactive",
      products: "10",
      orders: "10",
      lastActive: "June 9,2023",
    },
    {
      sr: "4",
      name: { src: Avatar, fullName: "Full Name" },
      phoneNumber: "03412302789",
      email: "Loremipsum@gmail.com",
      status: "Active",
      products: "10",
      orders: "10",
      lastActive: "June 9,2023",
    },
    {
      sr: "5",
      name: { src: Avatar, fullName: "Full Name" },
      phoneNumber: "03412302789",
      email: "Loremipsum@gmail.com",
      status: "Inactive",
      products: "10",
      orders: "10",
      lastActive: "June 9,2023",
    },
    {
      sr: "6",
      name: { src: Avatar, fullName: "Full Name" },
      phoneNumber: "03412302789",
      email: "Loremipsum@gmail.com",
      status: "Active",
      products: "10",
      orders: "10",
      lastActive: "June 9,2023",
    },
  ]

  const columns = [
    {
      name: "SR #",
      selector: (row) => row.sr,
      sortable: true,
      grow: 0.5,
    },
    {
      name: "Full Name",
      selector: (row) => row.name.fullName,
      sortable: true,
      cell: (row) => <FullNameAvatar src={row.name.src} fullName={row.name.fullName} />,
    },
    {
      name: "Phone Number",
      selector: (row) => row.phoneNumber,
      sortable: true,
    },
    {
      name: "Email",
      selector: (row) => row.email,
      sortable: true,
      wrap: true,
    },
    {
      name: "Status",
      selector: (row) => row.status,
      sortable: true,
      cell: (row) => <StatusBadge statusName={row.status} />,
    },
    {
      name: "Products",
      selector: (row) => <BlueBadge theme="yellow">{row.products}</BlueBadge>,
      sortable: true,
      center: "true",
    },
    {
      name: "Orders",
      selector: (row) => <BlueBadge>{row.orders}</BlueBadge>,
      sortable: true,
      center: "true",
    },
    {
      name: "Last Active",
      selector: (row) => row.lastActive,
      sortable: true,
    },
    {
      name: "Action",
      cell: () => <ActionButton options={actions} />,
      center: "true",
    },
  ]

  return (
    <LightGrayBgWrapper>
      <div className="bg-white p-3 shadow d-flex flex-column gap-2">
        <div className="fw-semibold fs-5">Sellers</div>

        <div className="d-flex align-items-center justify-content-between">
          <BlueTableHeading className="fw-semibold fs-5">Total Sellers: 100</BlueTableHeading>
          <SearchBar />
        </div>

        <GrayDivider />
        <DynamicDatatable columns={columns} data={data} pagination type="gray" />
      </div>
      {/* <div className={styles['wrapper']}>
        <input type="checkbox" />
        <div className={styles["white-circle"]}>
          <div className={styles["inner-yellow-circle"]}></div>
          <div className={styles["inner-white-circle"]}></div>
        </div>
      </div> */}
    </LightGrayBgWrapper>
  )
}

export default Sellers
